import { Router } from "@/router";
import { css, cx } from "@styled-system/css";
import { Box, Flex } from "@styled-system/jsx";
import { StarIcon } from "@/appContent/pricing";
import useI18n from "@/hooks/useI18n";
import { style } from "../styles";
import FreeCard from "./FreeCard";
import ProductList from "../ProductList";

export default function Products({ countryCode, products }: { countryCode: string; products: Product[] }) {
  const query = Router.getQuery();
  const { t } = useI18n();
  const { productsHeader } = style();

  if (query.from === "webapp")
    return (
      <Flex flexWrap="wrap" rowGap="1.5rem">
        <ProductList countryCode={countryCode} products={products} />
      </Flex>
    );

  return (
    <Flex flexGrow={1} rowGap="2rem" flexDir={["column", "row"]} flexWrap={["wrap", null, "nowrap"]}>
      <Box p="0 !important" mr={[0, null, "1rem"]} w={["100%", null, "25%"]}>
        <FreeCard currency={products[0]?.currency || ""} />
      </Box>
      <Flex
        className={css({
          borderRadius: "1.5rem",
          border: "1px solid",
          borderColor: "primaryTransparent",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1
        })}
      >
        <Flex
          className={cx(
            productsHeader,
            css({
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              borderRadius: "1.5rem 1.5rem 0 0"
            })
          )}
        >
          <StarIcon />
          <h6 className={css({ ml: "0.25rem", my: "0.375rem" })}>{t("premium")}</h6>
        </Flex>
        <Flex w="100%" flexWrap="wrap">
          <ProductList countryCode={countryCode} products={products} />
        </Flex>
      </Flex>
    </Flex>
  );
}
